module.exports = __webpack_public_path__ + "img/compatible-mev-srm-revenu-quebec.88f5f499.jpg";